import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { PrimengModule } from 'app/shared/modules/primeng.module';
import { ProductService, SampleComponent } from './sample.component';



const routes = [
    {
        path: '',
        component: SampleComponent,
        data: { title: 'Sample Page' }
    }
];

@NgModule({
    declarations: [
        SampleComponent
    ],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        HttpClientModule,
        FormsModule,
        PrimengModule
    ],
    providers: [ProductService],
    exports: [
        SampleComponent
    ]
})

export class SampleModule {
}
